// src/components/MobileBottomSheet.jsx
import {
  Box,
  Text,
  VStack,
  Button,
  IconButton,
  Slide,
} from "@chakra-ui/react";

export default function MobileBottomSheet({
  sector,
  isBusiness,
  onViewFlyer,
  onClose,
}) {
  if (!sector) return null;

  const households =
    sector.households ??
    sector.household_count ??
    sector.householdCount ??
    null;

  const booked =
    sector.bookedSlots ??
    sector.slots_available ??
    sector.slotsAvailable ??
    null;

  const roi =
    isBusiness
      ? sector.roi ??
        sector.roi_estimate ??
        sector.predicted_roi ??
        null
      : null;

  return (
    <Slide direction="bottom" in={!!sector} style={{ zIndex: 999999 }}>
      <Box
        bg="white"
        borderTopRadius="xl"
        shadow="xl"
        p={4}
        pb={6}
        position="relative"
      >
        <IconButton
          aria-label="Close"
          size="sm"
          variant="ghost"
          position="absolute"
          top="8px"
          right="8px"
          onClick={onClose}
        >
          ✕
        </IconButton>

        <VStack align="flex-start" spacing={2}>
          <Text fontSize="lg" fontWeight="bold" color="red.600">
            {sector.name}
          </Text>

          <Text fontSize="sm" color="gray.700">
            🏠 {households ? households.toLocaleString() : "No household data"}
          </Text>

          <Text fontSize="sm" color="gray.700">
            🎟️ {booked != null ? booked : "No slot data"}
          </Text>

          {roi && (
            <Text fontSize="sm" color="gray.700">
              💰 ROI: {roi}
            </Text>
          )}

          <Button
            mt={2}
            size="md"
            colorScheme="red"
            width="100%"
            onClick={onViewFlyer}
          >
            View flyer →
          </Button>
        </VStack>
      </Box>
    </Slide>
  );
}
